// Segnalazione su una riga dell'elenco: un altro operatore l'ha modificata dopo che l'elenco è stato caricato dall'operatore.
// Finché non la si riconosce (clic) o non si ricarica, l'eliminazione di quella riga risponde 409 invece di procedere.
export default function ModificataDaAltri({ onRiconosci }) {
  return (
    <button
      type="button"
      className="noStampa"
      onClick={onRiconosci}
      title="Un altro operatore ha modificato questa riga dopo che hai caricato l'elenco: controllala. Clicca per segnarla come vista."
      style={{ marginLeft: '0.4rem', fontSize: '0.72rem', background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d', borderRadius: 10, padding: '0 0.45rem', cursor: 'pointer' }}
    >
      modificata da altri
    </button>
  );
}
